import TaxCapitalGainsBracketsPage from '@playground/features/dictionary/TaxCapitalGainsBracketsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/tax-capital-gains-brackets'
)({
  component: TaxCapitalGainsBracketsPage,
})
